// @ts-nocheck
import { Plugin } from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','layout','layoutActionRef','request',],
});

export { plugin };
